export default "__VITE_ASSET__wF0EUGio__"